<!-- GenericList.vue -->
<template>
  <div class="generic-list">
    <Header
      v-if="persons.length < estimate"
      :page="config.id"
      :title_one="config.id"
      :action_one="event.main_actions ? 'add' : ''"
    />
    <Header
      v-else
      :page="config.id"
      :title_one="config.id"
    />
    <PersonTable
      :config="config"
      :persons="persons"
      :team="team"
      :estimate="estimate"
      :estimate-minimum="estimateMinimum"
      :error="error"
      :showEstimationDialog="showEstimationDialog"
      :showTransferDialog="showTransferDialog"
      :categories="categories"
      :playersException="playersException"
      :transferError="transferError"
      :isTransferring="isTransferring"
      @toggle-estimation-dialog="onToggleEstimationDialog"
      @toggle-transfer-dialog="onToggleTransferDialog"
      @load="load"
      @remove="remove"
      @update="update"
      @error="onError"
      @transfer="transfer"
    />
  </div>
</template>

<script>
// Component Hierarchy Overview:
// // config
// └── entity-list-config.js    ← one object keyed by route-name (`players`, `staff`, etc.)

import Header from '@/components/layout/Header.vue'
import PersonTable from './PersonTable.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'GenericList',
  components: { Header, PersonTable },
  props: {
    config: { type: Object, required: true },
    persons: { type: Array, required: true },
    team: { type: Object, required: true },
    error: { type: Boolean, default: false },
    showEstimationDialog: { type: Boolean, default: false },
    showTransferDialog: { type: Boolean, default: false },
    categories: { type: Object, required: false },
    playersException: {
      type: [Array, Boolean],
      default: false
    },
    transferError: {
      type: String,
      default: ''
    },
    isTransferring: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      estimate: null,
      estimateMinimum: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/getUser'
    }),
    
    event () {
      return this.$store.getters['getCurrentEvent']()
    }
  },
  watch: {
    team: {
      immediate: true,
      handler () {
        this.setEstimates()
      }
    }
  },
  methods: {
    load () {
      this.$emit('load')
    },
    remove (id) {
      this.$emit('remove', id)
    },
    update (id) {
      this.$emit('update', id)
    },
    transfer (playerId, teamId) {
      this.$emit('transfer', playerId, teamId)
    },
    setEstimates () {
      if (!this.config.estimate || !this.team || !this.team.team) return

      const field = this.config.estimate.field // e.g. 'estimate_players', 'estimate_staff'
      const teamFieldValue = this.team.team[field]
      this.estimate = teamFieldValue != null ? parseInt(teamFieldValue) : null

      const minField = this.config.estimate.minField
      if (minField && this.team.team.category && this.team.team.category.minimum_players != null) {
        this.estimateMinimum = parseInt(this.team.team.category.minimum_players)
      } else if (this.config.id === 'staff') {
        this.estimateMinimum = 1
      } else {
        this.estimateMinimum = 0
      }
    },
    onError (error) {
      this.$emit('error', error)
    },
    onToggleEstimationDialog (val) {
      this.$emit('toggle-estimation-dialog', val)
    },
    onToggleTransferDialog (val) {
      this.$emit('toggle-transfer-dialog', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.generic-list {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
